// extracted by mini-css-extract-plugin
module.exports = {"Messages":"Messages_Messages__1GA5G","GameStatus":"Messages_GameStatus__1ejBi","InputResponse":"Messages_InputResponse__2mVz2"};